<div class="mb-5 d-none d-lg-block shadow border rounded-3 overflow-hidden bg-white">
  <header class="p-3 bg-body-tertiary">
    <h5 class="m-0">{{ title }}</h5>
  </header>
  <ng-container *ngTemplateOutlet="menuItemsTemplate"></ng-container>
</div>
<div class="d-lg-none d-block shadow border rounded-3 overflow-hidden bg-white">
  <button
    type="button"
    aria-label="Превключване на навигацията"
    (click)="collapse.toggle()"
    [attr.aria-expanded]="!isMenuCollapsed"
    [class.bg-body-tertiary]="!isMenuCollapsed"
    class="w-100 px-3 py-2 btn border-0 text-muted">
    <div class="d-flex align-items-center justify-content-between">
      <div class="text-start">
        <h5 class="m-0 text-dark">{{ title }}</h5>
        <div>
          <small>{{ selectedItem?.title }}</small>
        </div>
      </div>
      <div>
        <i class="menu-icon fa-solid fa-chevron-down" [class.rotated]="!isMenuCollapsed"></i>
      </div>
    </div>
  </button>
  <div #collapse="ngbCollapse"
       [(ngbCollapse)]="isMenuCollapsed">
    <ng-container *ngTemplateOutlet="menuItemsTemplate"></ng-container>
  </div>
</div>
<ng-template #menuItemsTemplate>
  <ul class="m-0 list-unstyled ">
    @for (item of items; track item.id) {
      <li class="border border-start-0 border-end-0 border-bottom-0">
        <a [routerLink]="item.routerLink"
           [queryParams]="item.queryParams"
           [attr.aria-label]="item.title"
           (click)="collapse.toggle()"
           [queryParamsHandling]="queryParamsHandling"
           class="w-100 btn  rounded-0 border-0"
           [ngClass]="selectedItem?.id === item.id ? 'btn-nz-primary' : 'btn-outline-light text-dark'">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="my-2 text-start">
              @if (!!item.iconClass) {
                <i class="item-icon"
                   [class]="item.iconClass"
                   [ngClass]="selectedItem?.id === item.id ? 'text-light' : 'text-secondary'">
                </i>
              }
              {{ item.title }}
            </h6>
            @if (item.badge !== undefined) {
              <span class="badge  rounded-pill"
                    [ngClass]="selectedItem?.id === item.id ? 'bg-white text-nz-primary' : 'bg-secondary'">
                {{ item?.badge }}
              </span>
            }
          </div>
        </a>
      </li>
    }
  </ul>
</ng-template>
